import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-50d370b8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "partners"
};
const _hoisted_2 = {
  class: "text"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, null, -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, null, -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "top"
}, " 携手共创 ，互利共赢 ", -1));

const _hoisted_6 = {
  class: "partners-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_image = _resolveComponent("el-image");

  const _component_ArrowRight = _resolveComponent("ArrowRight");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createTextVNode(_toDisplayString(_ctx.title), 1), _hoisted_4, _hoisted_5]), _createElementVNode("div", _hoisted_6, [_ctx.partnerList.length > 1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "arrow",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    (...args) => _ctx.clickLeft && _ctx.clickLeft(...args))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowLeft)]),
    _: 1
  })])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnerList[_ctx.active], (cItem, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "partners-logo",
      key: cItem.id
    }, [_createVNode(_component_el_image, {
      src: _ctx.imgUrl(cItem.fileUrl),
      lazy: "",
      fit: "cover"
    }, null, 8, ["src"])]);
  }), 128)), _ctx.partnerList.length > 1 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "right-arrow",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    (...args) => _ctx.clickRight && _ctx.clickRight(...args))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
    _: 1
  })])) : _createCommentVNode("", true)])]);
}